<template>
  <b-form-group
    label="Kiracı Adı"
    label-for="title"
  >
    <b-form-input
      id="title"
      v-model="dataItem.tenants.title"
      readonly
      disabled
    />
  </b-form-group>
</template>
<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'TenantCode',
  components: {
    BFormInput,
    BFormGroup,
  },
  computed: {
    dataItem() {
      return this.$store.getters['estates/dataItem']
    },
  },
}
</script>
